import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { getData } from "features/dinamic";
import { setLoading } from "features/loader";
import { fetchMenu } from "features/menu";
import { setVisible } from "features/modal";
import { setDataToast, setVisibleToast } from "features/toast/toastBaseSlice";
import AlertInterface from "features/toast/toastInterface";

interface OpcionState {
    status: string;
    error: string;
    opcionList: any[],
    opcionListActive: any[],
    opcion: {
        idOpcion: number | null;
        nombre: string | null;
        descripcion: string | null;
        etiqueta: string | null;
        orden: number | null;
        icono: string | null;
        movil: number | null;
        idOpcionPadre: number | null;
        opcionPadre: string | null;
        estado: number | null;
    }
}

const initialState: OpcionState = {
    status: 'idle',
    error: '',
    opcionList: [],
    opcionListActive: [],
    opcion: {
        idOpcion: null,
        nombre: null,
        descripcion: null,
        etiqueta: null,
        orden: null,
        icono: null,
        movil: null,
        idOpcionPadre: null,
        opcionPadre: null,
        estado: null,
    }
}

export const fetchOpcion = createAsyncThunk('fetchOpcion', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 24;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchOpcionActive = createAsyncThunk('fetchOpcionActive', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const opcion = selectOpcion(state);
    const opcionAttributes = { ...opcion }
    const idOpcion = opcionAttributes.idOpcion;
    const idsp = 25;
    const { result, message, data } = await getData({ idsp, idOpcion }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const modifyCreateOpcion = createAsyncThunk('modifyCreateOpcion', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const opcion = selectOpcion(state);
    const opcionAttributes = { ...opcion }
    const idsp = opcionAttributes.idOpcion ? 22 : 21;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, ...opcionAttributes }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        dispatch(setVisible(false));
    }
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 5000);
    dispatch(fetchOpcion({}));
    dispatch(fetchMenu({}));
    return rejectWithValue(message);
});

export const updateEstadoOpcion = createAsyncThunk('updateEstadoOpcion', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const opcion = selectOpcion(state);
    const opcionAttributes = { ...opcion }
    const estado = !opcionAttributes.estado;
    const idOpcion = opcionAttributes.idOpcion;
    const idsp = 23;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, estado, idOpcion }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setVisible(false));
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 5000);
    dispatch(fetchOpcion({}));
    dispatch(fetchMenu({}));
    return rejectWithValue(message);
});

export const opcionSlice = createSlice({
    name: 'opcion',
    initialState,
    reducers: {
        setOpcionList: (state, action) => {
            state.opcionList = action.payload;
        },
        setOpcion: (state, action) => {
            state.opcion = !action.payload ? initialState.opcion : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchOpcion.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchOpcion.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.opcionList = data ? data : [];

            })
            .addCase(fetchOpcion.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchOpcionActive.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchOpcionActive.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.opcionListActive = data ? data : [];

            })
            .addCase(fetchOpcionActive.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(modifyCreateOpcion.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(modifyCreateOpcion.fulfilled, (state, action) => {
                state.status = 'completed';

            })
            .addCase(modifyCreateOpcion.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(updateEstadoOpcion.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateEstadoOpcion.fulfilled, (state, action) => {
                state.status = 'completed';

            })
            .addCase(updateEstadoOpcion.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })

    },

})

export const selectOpcionList = (state: RootState) => state.opcion.opcionList;
export const selectOpcionListActive = (state: RootState) => state.opcion.opcionListActive;
export const selectOpcion = (state: RootState) => state.opcion.opcion;

export const { setOpcionList, setOpcion } = opcionSlice.actions;

export default opcionSlice.reducer;
